var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedProteinV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06442 5.90616C11.4556 3.14509 14.1954 4.07895 14.226 4.08749C14.2722 4.10527 14.312 4.13727 14.3398 4.17924C14.6221 4.68138 14.7971 5.23902 14.8497 5.81228L14.8703 6.78882C14.7565 7.82298 14.3575 8.80521 13.7188 9.62742C13.8341 10.3003 13.8042 10.9895 13.6313 11.6488C13.4599 12.3081 13.1505 12.9241 12.7231 13.4561C12.6953 13.4916 12.6562 13.5172 12.6121 13.5308C12.5695 13.545 12.5232 13.545 12.4798 13.5322C12.4365 13.5201 12.3966 13.4952 12.3675 13.4603C12.3383 13.4262 12.3198 13.3835 12.3148 13.3387C12.2259 12.7249 11.9635 12.1481 11.5581 11.6765C10.5929 12.3401 9.54522 12.8764 8.44136 13.2719C8.51462 13.7811 8.48119 14.3003 8.34178 14.7968C8.20451 15.2932 7.96412 15.7548 7.63908 16.1538C7.61205 16.1837 7.57648 16.2051 7.53878 16.2179C7.50109 16.2307 7.46055 16.2328 7.42072 16.2243C7.38018 16.2179 7.34391 16.2015 7.31261 16.1766C7.28061 16.151 7.25713 16.1183 7.24148 16.0813C7.10563 15.6617 6.66893 14.5002 6.27348 14.1851C5.87589 13.8686 4.64684 13.7015 4.19804 13.6687C4.1575 13.6631 4.12051 13.6467 4.08922 13.6218C4.05792 13.5962 4.03303 13.5635 4.0188 13.5258C4.00245 13.4881 3.99677 13.4461 4.00174 13.4049C4.00672 13.3636 4.02378 13.3245 4.04939 13.2925C4.36447 12.8857 4.76064 12.5485 5.21371 12.3024C5.66678 12.0571 6.16393 11.9077 6.67817 11.8657C6.70733 11.663 6.73507 11.4447 6.77419 11.2114L6.98685 10.1808C7.12982 9.59827 7.31331 9.02642 7.53522 8.47022C6.98685 8.18217 6.36664 8.05626 5.74999 8.10676C5.70589 8.11174 5.65966 8.10392 5.61912 8.08187C5.57858 8.06053 5.54515 8.02854 5.52452 7.98871C5.50176 7.94888 5.49252 7.90406 5.49536 7.85854C5.49963 7.81373 5.51599 7.77036 5.54373 7.73479C5.96764 7.1978 6.50036 6.75681 7.10634 6.44172C7.71517 6.12593 8.38233 5.94386 9.06442 5.90616Z",
    fill: "#FC4871",
    stroke: "#FC4871",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2072 7.74189C12.6773 7.71486 12.1624 7.51857 11.7406 7.18215C11.3181 6.84572 11.0123 6.38769 10.8672 5.87701",
    stroke: "#FFECF1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedProteinV2);
export default __webpack_public_path__ + "static/media/rounded-protein-v2.384089b7dcac78e01074f661935eb2fd.svg";
export { ForwardRef as ReactComponent };